   <div class=" flex flex-col gap-5 ticket mx-auto  mt-5 px-4">
      <div class="flex flex-col gap-0 justify-between  bg-white rounded-xl shadow-md max-w-md w-full mx-auto  px-4" >
          <div class="items-center  border-b-2  " style="border-color: #EEE;">
            <p class="texte-reviews my-4">{{ 'DRIVER_REVIEWS.RATE_DRIVER' | translate }}</p>
          </div>
          <div class="flex flex-col py-4 self-stretch border-b-2 " style="border-color: #EEE;">
            <div class="flex items-center gap-5 flex-[1_0_0] ">
              <div class="flex justify-center items-center  w-[60px] h-[60px]">
                <img  *ngIf="driverInfo.driverPhoto"
                  [src]="loadImage(driverInfo.driverPhoto || 'driver-photo.png')" 
                  alt="Driver Photo"
                  class="driver-profile-image"
                  onerror="this.src='/icons/driver-photo.png'">
              </div>
              <div class="flex flex-col justify-center items-start gap-2">
                <div class="driver-name">{{driverInfo.driverFullName || ''}}</div>
                <div class="text-driver-plate">{{driverInfo.driverCarModel || ''}}</div>
             </div>
            <div class="flex flex-col justify-center items-end gap-2 w-[100px] ml-auto">
             <div class="flex ">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                <path opacity="0.4" d="M9.81361 0.594841L11.669 4.3234C11.8057 4.59354 12.0666 4.78114 12.3675 4.82282L16.535 5.4298C16.7784 5.46398 16.9993 5.59238 17.1485 5.78831C17.296 5.98175 17.3594 6.22687 17.3236 6.46783C17.2944 6.66793 17.2002 6.85302 17.056 6.99476L14.0362 9.92208C13.8153 10.1264 13.7153 10.429 13.7686 10.725L14.5121 14.8404C14.5913 15.3373 14.2621 15.8059 13.7686 15.9001C13.5652 15.9326 13.3569 15.8985 13.1735 15.8051L9.45603 13.8683C9.18014 13.729 8.85423 13.729 8.57834 13.8683L4.86088 15.8051C4.40411 16.0477 3.83816 15.8826 3.58393 15.4324C3.48975 15.2531 3.45641 15.0489 3.48725 14.8496L4.23074 10.7333C4.28409 10.4382 4.18323 10.1339 3.96318 9.92959L0.943368 7.00393C0.584124 6.65709 0.573288 6.08597 0.919196 5.72662C0.926697 5.71911 0.935033 5.71078 0.943368 5.70244C1.08673 5.55653 1.27511 5.46398 1.47848 5.4398L5.64604 4.832C5.94611 4.78947 6.207 4.60355 6.34453 4.33174L8.13324 0.594841C8.29245 0.274678 8.62252 0.0754104 8.98093 0.0837479H9.09262C9.40352 0.121267 9.67441 0.313865 9.81361 0.594841Z" fill="url(#paint0_linear_1260_1350)"/>
                <path d="M8.99336 13.7644C8.83195 13.7694 8.67469 13.8128 8.53324 13.8904L4.83395 15.8228C4.38132 16.0388 3.83966 15.8712 3.58588 15.4383C3.49186 15.2615 3.45775 15.0588 3.48936 14.8603L4.22822 10.7528C4.27815 10.4542 4.1783 10.1506 3.96114 9.94046L0.939968 7.01556C0.581355 6.66444 0.574699 6.08813 0.925823 5.72867C0.930816 5.72367 0.934976 5.7195 0.939968 5.71533C1.08308 5.57354 1.2678 5.48013 1.46665 5.45094L5.63771 4.83711C5.93975 4.79874 6.20184 4.61025 6.33497 4.3367L8.148 0.552761C8.32024 0.247511 8.65056 0.0656953 9.00002 0.0848777C8.99336 0.332581 8.99336 13.596 8.99336 13.7644Z" fill="url(#paint1_linear_1260_1350)"/>
                <defs>
                  <linearGradient id="paint0_linear_1260_1350" x1="17.3334" y1="15.9168" x2="-2.33372" y2="9.91442" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FEBB1B"/>
                    <stop offset="1" stop-color="#FFC740"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_1260_1350" x1="9.00002" y1="15.9168" x2="-1.50486" y2="14.3138" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FEBB1B"/>
                    <stop offset="1" stop-color="#FFC740"/>
                  </linearGradient>
                </defs>
              </svg>
              <span class="text-driver-rating">{{(driverInfo.driverAvgRatings | number:'1.0-2') || ''}}</span>
             </div>
             <div class="mat-driver-plate">
              {{driverInfo.driverCarPlateNumber || ''}}
             </div>
            
            </div>
           </div>

      
        
        
        </div>
        <div class="my-4 flex flex-col gap-2">

            <div class="question-to-client  items-center ">
              {{ 'DRIVER_REVIEWS.HOW_IS_DRIVER' | translate }}
            </div>
             <div class=" question-to-client-para items-center gap-2">
             {{ 'DRIVER_REVIEWS.PLEASE_RATE' | translate }}
            </div>

            <div class="starts border-b-2 py-4">
              <div class="start" 
                   *ngFor="let star of [1,2,3,4,5]; let i = index"
                   [class.star-selected]="isStarFilled(star)"
                   (click)="selectRating(star)"
                   (mouseenter)="hoverRating(star)"
                   (mouseleave)="resetHover()">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
                  <path d="M26.8642 19.867C26.4325 20.2853 26.2342 20.8903 26.3325 21.4837L27.8142 29.6837C27.9392 30.3787 27.6458 31.082 27.0642 31.4837C26.4942 31.9003 25.7358 31.9503 25.1142 31.617L17.7325 27.767C17.4758 27.6303 17.1908 27.557 16.8992 27.5487H16.4475C16.2908 27.572 16.1375 27.622 15.9975 27.6987L8.61416 31.567C8.24916 31.7503 7.83583 31.8153 7.43083 31.7503C6.44416 31.5637 5.78583 30.6237 5.9475 29.632L7.43083 21.432C7.52916 20.8337 7.33083 20.2253 6.89916 19.8003L0.880829 13.967C0.377496 13.4787 0.202496 12.7453 0.432496 12.0837C0.655829 11.4237 1.22583 10.942 1.91416 10.8337L10.1975 9.63199C10.8275 9.56699 11.3808 9.18366 11.6642 8.61699L15.3142 1.13366C15.4008 0.966992 15.5125 0.813659 15.6475 0.683659L15.7975 0.566992C15.8758 0.480325 15.9658 0.408659 16.0658 0.350326L16.2475 0.283659L16.5308 0.166992H17.2325C17.8592 0.231992 18.4108 0.606992 18.6992 1.16699L22.3975 8.61699C22.6642 9.16199 23.1825 9.54033 23.7808 9.63199L32.0642 10.8337C32.7642 10.9337 33.3492 11.417 33.5808 12.0837C33.7992 12.752 33.6108 13.4853 33.0975 13.967L26.8642 19.867Z" 
                        [attr.fill]="isStarFilled(star) ? '#FEBB1B' : '#E0E0E0'"/>
                </svg>
              </div>
            </div>

            <!-- Comment Section -->
            <div class="my-4 flex flex-col gap-2">
              <div class="comment-label">
                {{ 'DRIVER_REVIEWS.ADD_COMMENT' | translate }}
              </div>
              <textarea 
                class="comment-textarea"
                [(ngModel)]="comment"
                [placeholder]="'DRIVER_REVIEWS.COMMENT_PLACEHOLDER' | translate"
                rows="3"
                maxlength="500"
                [disabled]="isSubmitting">
              </textarea>
              <div class="comment-counter" [class.comment-counter-warning]="comment.length > 450">
                {{ 'DRIVER_REVIEWS.CHARACTER_COUNT' | translate: {count: comment.length} }}
              </div>
            </div>

            <div class="flex justify-center items-center mt-4">
              <button class="submit-button"
                      [disabled]="selectedRating === 0 || isSubmitting"
                      [class.submit-button-disabled]="selectedRating === 0 || isSubmitting"
                      (click)="submitDriverFeedback()">
                <span class="submit-text" *ngIf="!isSubmitting">{{ 'DRIVER_REVIEWS.SUBMIT' | translate }}</span>
                <span class="submit-text" *ngIf="isSubmitting">{{ 'DRIVER_REVIEWS.SUBMITTING' | translate }}</span>
              </button> 
           </div>
     </div>
  </div>
